const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "대상년도",
        value: "year",
        query: { y: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
          maxYear: new Date().getFullYear() + 1,
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "대상년도", "작성일", "첨부파일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    const year = search.year;
    conditions.push({ key: "body.subInfo.대상년도", operator: "=", value: `${year}` });

    // 사업장
    const params = new URLSearchParams(window.location.search);
    const fd = params.get("fd");
    conditions.push({ key: "body.stdInfo.field_name", operator: "=", value: fd });

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "body.subInfo.대상년도",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
      {
        name: "작성일",
        key: "created_at",
      },
      {
        name: "첨부파일",
        key: "body.stdInfo.photoList",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).subInfo.대상년도; // 대상년도
        case 1:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 2:
          return func.getContent(value).stdInfo.writer_name; // 작성자
        case 3:
          return func.getCreatedDate(value.created_at); // 작성일
        case 4: {
          const file = func.getContent(value).fileList;
          return {
            type: "file",
            files: file,
          };
        }
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
